/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { RouteObject } from 'react-router'
import ProspectingFormPage from './ProspectingFormPage'
import ProspectingListPage from './ProspectingListPage'

export const prospectingRoutes: RouteObject[] = [
  {
    index: true,
    element: <ProspectingListPage />
  },
  {
    path: 'create',
    element: <ProspectingFormPage />
  },
  {
    path: ':id/*',
    children: [
      {
        path: 'edit',
        element: <ProspectingFormPage />
      }
    ]
  }
]
